import React from 'react';
import { useNavigate } from 'react-router-dom';

const ExamSubmitted: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center">
      <div className="bg-white rounded-xl shadow-2xl p-8 sm:p-12 max-w-md w-full text-center">
        <div className="text-green-600 text-5xl mb-4">✅</div>
        <h1 className="text-2xl sm:text-3xl font-bold mb-2">Exam Submitted Successfully!</h1>
        <p className="text-gray-600 mb-6">
          Thank you for completing the contest. Your responses have been recorded.
        </p>
        <p className="text-sm text-gray-400 mb-8">
          The results will be announced on the specified result date.
        </p>
        <button
          onClick={() => navigate('/')}
          className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-3 px-6 rounded-lg transition"
        >
          Go to Home
        </button>
      </div>
    </div>
  );
};

export default ExamSubmitted;
